export default "__VITE_ASSET__Dj_H3Hmb__"